import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";

export const Route = createFileRoute("/_authenticated/admin/drivers/$userId")({
	head: () => pageTitle("Driver"),
	component: RouteComponent,
});

function RouteComponent() {
	const { userId } = Route.useParams();
	return <div>Member Detail: {userId}</div>;
}
